import React from "react";
import { Modal, Steps, Form, Space, Button, Alert } from "antd";
import { useTranslation } from "react-i18next";
import { FileTextOutlined } from "@ant-design/icons";

import { useEvaluationWizard } from "./useEvaluationWizard";
import { EvaluationWizardStep1TypeArea } from "./steps/EvaluationWizardStep1TypeArea";
import { EvaluationWizardStep2Identity } from "./steps/EvaluationWizardStep2Identity";
import { EvaluationWizardStep3Questions } from "./steps/EvaluationWizardStep3Questions";
import { EvaluationWizardStep4Share } from "./steps/EvaluationWizardStep4Share";

import "./EvaluationWizard.scss";

export function EvaluationWizard({ isOpen, onClose, onSuccess, initialData }) {
  // "Cancelar", "Siguiente" y "Guardar cambios" salen de common: son las mismas
  // en todo el portal y no se repiten namespace a namespace.
  const { t } = useTranslation(["evaluations", "common"]);

  const {
    form,
    step,
    stepItems,
    submitting,
    subtype,
    isEditing,
    isStandard,
    role,
    next,
    prev,
    submit,
    pickTemplate,
    moveQuestion,
  } = useEvaluationWizard({ isOpen, initialData, onClose, onSuccess });

  return (
    <Modal
      title={
        <Space size={10}>
          <FileTextOutlined />
          <span>
            {isEditing
              ? t("asistente.titulos.editar")
              : t("asistente.titulos.crear")}
          </span>
        </Space>
      }
      open={isOpen}
      onCancel={onClose}
      width={1100}
      centered
      destroyOnHidden
      className="revi-eval-wizard"
      footer={
        <div className="revi-eval-wizard__footer">
          <Space>
            <Button onClick={onClose}>{t("common:actions.cancel")}</Button>
          </Space>

          <Space>
            {step > 0 ? (
              <Button onClick={prev}>{t("asistente.acciones.atras")}</Button>
            ) : null}
            {step < 3 ? (
              <Button type="primary" onClick={next}>
                {t("common:actions.next")}
              </Button>
            ) : (
              <Button type="primary" loading={submitting} onClick={submit}>
                {isEditing
                  ? t("common:actions.saveChanges")
                  : t("asistente.acciones.crear")}
              </Button>
            )}
          </Space>
        </div>
      }
    >
      {isStandard ? (
        <Alert
          type="warning"
          showIcon
          message={t("asistente.estandar.aviso")}
          description={t("asistente.estandar.detalle")}
          style={{ marginBottom: 12 }}
        />
      ) : null}

      <Steps
        current={step}
        items={stepItems}
        className="revi-eval-wizard__steps"
      />

      <div style={{ marginTop: 16 }}>
        <Form form={form} layout="vertical" className="revi-eval-wizard__form">
          {/* Must stay mounted across all steps: Form.useWatch returns undefined once the Form.Item unmounts. */}
          <Form.Item
            name="subtype"
            rules={[
              { required: true, message: t("asistente.validacion.tipo") },
            ]}
            style={{ display: "none" }}
          >
            <input type="hidden" />
          </Form.Item>

          {step === 0 ? (
            <EvaluationWizardStep1TypeArea
              subtype={subtype}
              onPickTemplate={pickTemplate}
            />
          ) : null}

          {step === 1 ? (
            <EvaluationWizardStep2Identity subtype={subtype} />
          ) : null}

          {step === 2 ? (
            <EvaluationWizardStep3Questions
              form={form}
              subtype={subtype}
              onMoveQuestion={moveQuestion}
            />
          ) : null}

          {step === 3 ? <EvaluationWizardStep4Share role={role} /> : null}
        </Form>
      </div>
    </Modal>
  );
}

export default EvaluationWizard;
